import React from 'react';
import { useSearchParams } from 'react-router-dom';

import Buscando from 'Component/Buscando';
import Cabecalho from 'Component/Cabecalho';
import { EmprestimoEpiLista } from 'Component/EmprestimoEpi';
import LayoutDefault from 'Component/Layout';
import Paginacao from 'Component/Paginacao';
import SemRegistros from 'Component/SemRegistros';
import { useAppSelector } from 'Store';
import { useRecuperarEmprestimosEpiQuery } from 'View/Service/Default/EmprestimosEpi';

const Historico = (): React.ReactElement => {
  const [searchParams] = useSearchParams();

  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);

  const {
    data: { emprestimos, paginacao } = {},
    isFetching,
    isLoading,
  } = useRecuperarEmprestimosEpiQuery({
    contain: ['Epis'],
    page: searchParams.get('pagina') || 1,
    options: { usuario_id: usuario?.id, assinado: 0 },
  });

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Emprestimos de EPIs"
        descricao="Veja todos seus emprestimos de EPIs não assinados."
      />
      <Buscando exibir={isLoading} />
      <SemRegistros carregando={isLoading} registros={emprestimos?.length} />
      <React.Fragment>
        <div className="bg-white shadow-sm rounded">
          {emprestimos?.map((emprestimo) => (
            <EmprestimoEpiLista
              key={`${emprestimo.id}-${emprestimo.modificado}`}
              dados={emprestimo}
            />
          ))}
        </div>
      </React.Fragment>
      <Paginacao dados={paginacao} desabilitado={isFetching} />
    </LayoutDefault>
  );
};

export default Historico;
